import { useMutation } from '@tanstack/react-query';

import { postAssistantEnhancePrompt } from '@/api/generated/assistant/assistant';

export const useEnhancePrompt = () =>
  useMutation({
    mutationFn: async (prompt: string) => {
      const response = await postAssistantEnhancePrompt({ prompt });
      return response;
    },
  });
